<template lang="pug">
  .post-images
    img.post-images__preview(
      :src="images[0].url"
      @click="openFancy"
    )
    div(
      style="width: 0; height: 0; overflow: hidden;"
      ref="fancy"
    )
      img(
        v-for="image in images"
        :src="image.url"
        :href="image.url"
        :data-fancybox="id + itemIndex"
      )
</template>

<script>
export default {
  name: 'postImages',
  props: {
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: String,
      default: '0',
    },
    itemIndex: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    openFancy() {
      this.$refs.fancy.querySelectorAll('img')[0].click();
    },
  },
};
</script>

<style lang="stylus">
.post-images
  width 6em
  display flex
  align-items flex-start
  justify-content center
  margin 0 1em
  flex-shrink 0
  position relative
  &__preview
    width auto
    max-width 100%
    cursor pointer
    &:hover
      transform scale(1.02)
  &__count
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    text-align center
    font-size 3em
    color #460303
</style>
